
import WebService from "../WebService"
const User = {
    gets() {
        return WebService.get("/console/users")
    },
    get(id, params) {
        return WebService.get("/user/" + id + '?' + params)
    },
    update(data, params) {
        return WebService.post("/user/" + data.id + '?' + params, data)
    },
    create(data, params) {
        return WebService.post("/user?" + params, data)
    },
    invite(data, params) {
        return WebService.post("/user/invite?" + params, data)
    },
    search(data) {
        return WebService.post("/console/users/search", data)
    },
}
export default User